import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { BaseComponent } from '../base.component';
import * as NavigationActions from 'src/app/store/common/navigation/navigation.actions';

@Component({
    selector: 'submit-button',
    templateUrl: './submit-button.component.html',
    styleUrls: ['./submit-button.component.scss']
})

export class SubmitButtonComponent extends BaseComponent implements OnInit {

    @Input('text') text: string = 'Save';
    @Input('class') class: string = 'btn btn-dark w-100';
    @Output('submit') onClick: EventEmitter<any> = new EventEmitter();
    @Input('type') type: string = 'submit';

    subscription: Subscription[] = [];

    constructor(store: Store) {
        super(store);
    }

    ngOnInit(): void {
      
    }

    click() {
        this.store.dispatch(NavigationActions.showSpinner({}));
        this.onClick.emit();
    }

    ngOnDestroy() {
        this.subscription.forEach(a => a.unsubscribe());
    }
}




